import { BeehiivPublicationIds } from '@blockworks/platform/api/beehiiv';

export const DEFAULT_SUBSCRIPTION_DATA = {
    name: 'The Breakdown',
    subscriptionType: BeehiivPublicationIds.TheBreakdown,
};

const getBeehiivPublicationsData = (categories: string[]) => {
    for (const category of categories) {
        switch (category) {
            case 'Forward Guidance Newsletter':
                return {
                    name: 'Forward Guidance Newsletter',
                    subscriptionType: BeehiivPublicationIds.ForwardGuidance,
                };
            case 'Lightspeed Newsletter':
                return {
                    name: 'Lightspeed Newsletter',
                    subscriptionType: BeehiivPublicationIds.Lightspeed,
                };
            case 'Empire Newsletter':
                return {
                    name: 'Empire Newsletter',
                    subscriptionType: BeehiivPublicationIds.Empire,
                };
            default:
                break;
        }
    }

    return DEFAULT_SUBSCRIPTION_DATA;
};

export { getBeehiivPublicationsData };
